import { render, staticRenderFns } from "./OtherActivitiesAttribution.vue?vue&type=template&id=ecc1f6b2&scoped=true"
import script from "./OtherActivitiesAttribution.vue?vue&type=script&lang=js"
export * from "./OtherActivitiesAttribution.vue?vue&type=script&lang=js"
import style0 from "./OtherActivitiesAttribution.vue?vue&type=style&index=0&id=ecc1f6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc1f6b2",
  null
  
)

export default component.exports